import * as React from 'react';
import * as Constants from 'src/constants';
import * as Layout from 'src/components/Layout';
import NavBar from 'src/views/Marketing/components/NavBar';
import Footer from 'src/views/Marketing/components/Footer';
import { ScrollView, StyleSheet, Text, View } from 'react-native';

const Screen: React.FC<{}> = () => {
  return (
    <>
      <ScrollView style={styles.scrollView}>
        <NavBar />
        <Layout.EdgeGutter style={styles.contentContainerStyle}>
          <View style={styles.content}>
            <Text style={[Constants.TextStyle.T42B]}>{'Electronic Communications Disclosure and Consent'}</Text>
            <p>
              {
                'You have requested OneShop’s online services where you can subscribe to a OneShop subscription, manage your subscription, request services, and contact our team (collectively, “Online Services”). By utilizing any of OneShop’s Online Services, you agree that OneShop may, but is not obligated to, send any and all of its communications to you electronically (collectively referred to as “Electronic Communications”).Electronic Communications may include information related to any of OneShop’s Online Services or other products, services or features or our decisions related to your service. Electronic Communications may also include important information such as, but not restricted to, notices regarding privacy, changes in terms, and periodic statements, as are required under applicable law.This Electronic Communications Disclosure and Consent form informs you of your rights when receiving these Electronic Communications. If you do not wish to receive communications electronically from us, you may make your request by reaching out to our support lines.'
              }
            </p>
            <h2>{'Consent and Acknowledgement'}</h2>
            <p>
              {
                'By continuing to open your account online, you acknowledge receipt of this Electronic Communications Disclosure and Consent form, evidence your intent to be bound by all terms contained herein regarding the Electronic Communications above, and consent to the delivery of Electronic Communications via the internet to an e-mail address you designate to receive such Electronic Communications and by SMS (commonly known as text messages). You also confirm that you meet the Hardware and Software Requirements listed below and are able to access and retain Electronic Communications from us.'
              }
            </p>
            <p>
              {
                'Your Consent to Electronic Communications applies to all Electronic Communications that we provide to you in connection with your Online Services activity or requests, products and services which you have in the past, now or in the future. If you consent to Electronic Communications, we will provide the Electronic Communication on our website. That communication will include instructions on how to access the information from our website.'
              }
            </p>
            <h2>{'Hardware and Software Requirements'}</h2>
            <p>
              {
                'To receive Electronic Communications, you must ensure that you are able to receive and retain information electronically. You must have a computer system with an Internet Web browser capable of 128-bit encryption and Adobe Acrobat Reader in order to receive disclosures electronically. Further, you must have a printer capable of printing any disclosures or statements that are made available on our website and/or emailed to you, and/or have the ability to electronically save and visually display on computer screens such documents. You must ensure that you are able to receive and read SMS text messages from OneShop and related services.'
              }
            </p>
            <h2>{'Updating Contact Information'}</h2>
            <p>
              {
                'You are responsible for ensuring that we have your current e-mail address and phone numbers for purposes of receiving Electronic Communications. If your phone number changes, you can update it via reaching out to our support. If you fail to notify us of any change in your e-mail address or phone numbers, you agree that we may provide Electronic Communications to you at the e-mail address or phone numbers maintained in our records and provided by you. Any Electronic Communications we send to you will be deemed to have been provided on the date we deliver the e-mail or SMS text message to you.'
              }
            </p>
          </View>
        </Layout.EdgeGutter>
        <Footer />
      </ScrollView>
    </>
  );
};

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
  contentContainerStyle: {
    alignItems: 'center',
    paddingTop: 6 * Constants.Grid.dp(12),
  },
  content: {
    width: '100%',
    maxWidth: Constants.Grid.dp(640),
  },
  contactMethodRow: {
    alignItems: 'center',
  },
  contactMethodColumn: {
    maxWidth: Constants.Grid.dp(200),
    flex: 1,
    alignItems: 'center',
  },
});

export default Screen;
